import etReferenceDataConfig from '@/api/config/etReferenceDataConfig'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { Historical } from '@/types/historical'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchEtReference(
  searchParams: SearchParams = {},
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<Historical>, any> {
  return useQuery(
    [queryKeys.etReference, interfaceId, searchParams],
    async () => {
      const { data } = await etReferenceDataConfig.getAll({
        ...searchParams,
        interfaceId,
      })

      if (!data) return null

      return {
        list: data?.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchEtReference
